import { jsx as _jsx } from "react/jsx-runtime";
// MARK://dhk8/ui/components/TenantBranding
// Tenant branding cascada. Inyecta CSS vars en <html> style attr.
// Default: SCMDG branding (usa valores del sistema).
import { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
const TenantBrandingContext = createContext(null);
function buildStyleVars(config) {
    const parts = [];
    if (config.primary)
        parts.push(`--dhk8-tenant-primary: ${config.primary}`);
    if (config.secondary)
        parts.push(`--dhk8-tenant-secondary: ${config.secondary}`);
    if (config.onPrimary)
        parts.push(`--dhk8-tenant-on-primary: ${config.onPrimary}`);
    if (config.logoUrl)
        parts.push(`--dhk8-tenant-logo: url(${config.logoUrl})`);
    if (config.name)
        parts.push(`--dhk8-tenant-name: "${config.name}"`);
    return parts.join('; ');
}
export function TenantBrandingProvider({ config: initialConfig = {}, children, }) {
    const [config, setConfigState] = useState(initialConfig);
    const [previewConfig, setPreviewConfigState] = useState(null);
    const prevStyleRef = useRef('');
    useEffect(() => {
        const active = previewConfig ?? config;
        const styleStr = buildStyleVars(active);
        if (styleStr !== prevStyleRef.current) {
            document.documentElement.style.cssText = styleStr;
            prevStyleRef.current = styleStr;
        }
    }, [config, previewConfig]);
    const setConfig = useCallback((c) => {
        setConfigState(c);
    }, []);
    const setPreviewConfig = useCallback((c) => {
        setPreviewConfigState(c);
    }, []);
    return (_jsx(TenantBrandingContext.Provider, { value: { config, setConfig, previewConfig, setPreviewConfig }, children: children }));
}
export function useTenantBranding() {
    const ctx = useContext(TenantBrandingContext);
    if (!ctx)
        throw new Error('useTenantBranding debe usarse dentro de <TenantBrandingProvider>');
    return ctx;
}
/**
 * Hook para preview override sin commit (usado en página settings).
 * Mientras se mantiene el preview, los vars del tenant se sobreescriben temporalmente.
 */
export function useTenantBrandingPreview() {
    const { previewConfig, setPreviewConfig } = useTenantBranding();
    const startPreview = useCallback((config) => {
        setPreviewConfig(config);
    }, [setPreviewConfig]);
    const stopPreview = useCallback(() => {
        setPreviewConfig(null);
    }, [setPreviewConfig]);
    return { previewConfig, startPreview, stopPreview };
}
//# sourceMappingURL=TenantBranding.js.map